import { Action, createReducer, on } from '@ngrx/store';
import { IBusinessDetailParams } from '../models/business-detail.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import {
  clearBusinessDetail,
  loadBusinessDetailUpdates,
  loadBusinessDetailUpdatesFailure,
  loadBusinessDetailUpdatesSuccess
} from '../actions/business-detail-update.actions';

export const businessDetailUpdateFeatureKey = 'businessDetailUpdate';

export interface BusinessDetailUpdateState {
  updateBusinessDetailRequest: any;
  updateBusinessDetailResponse: any;
  updateBusinessDetailFailure: IGenericError<ErrorResponse>;
}

export const initialState: BusinessDetailUpdateState = {
  updateBusinessDetailRequest: undefined,
  updateBusinessDetailResponse: undefined,
  updateBusinessDetailFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadBusinessDetailUpdates, (state, action) => ({
    ...state,
    updateBusinessDetailRequest: action.request
  })),
  on(loadBusinessDetailUpdatesSuccess, (state, action) => ({
    ...state,
    updateBusinessDetailResponse: action.response
  })),
  on(loadBusinessDetailUpdatesFailure, (state, action) => ({
    ...state,
    updateBusinessDetailFailure: action.error
  })),
  on(clearBusinessDetail, (state, action) => ({
    ...state,
    updateBusinessDetailResponse: undefined
  }))
);

export const getUpdateBusinessDetailRequest = (state: BusinessDetailUpdateState) => state.updateBusinessDetailRequest;
export const getUpdateBusinessDetailResponse = (state: BusinessDetailUpdateState) => {
  return state.updateBusinessDetailResponse;
};

export const getUpdateBusinessDetailFailure = (state: BusinessDetailUpdateState) => state.updateBusinessDetailFailure;
